import firebase from 'firebase'

const config: any = {
  apiKey: process.env.VUE_APP_FB_API_KEY,
  authDomain: process.env.VUE_APP_FB_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FB_DB_URL,
  projectId: process.env.VUE_APP_FB_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FB_APP_ID
}

const firebaseApp = firebase.initializeApp(config)
const firebaseAuth = firebase.auth

const getCurrentToken = async () => {
  return firebase.auth().currentUser!.getIdToken(false)
}

const getCurrentUser = async () => {
  const user = await firebase.auth().currentUser
  if (!user) return Promise.resolve(false)
  const provider = user?.providerData[0]
  const result = {
    uid: provider?.providerId === 'microsoft.com' ? provider?.uid : user?.uid,
    name: user?.displayName,
    email: user?.email,
    picture: user?.photoURL,
    signInMethod: provider?.providerId,
    refreshToken: user?.refreshToken
  }
  return result
}

const signInGoogle = async () => {
  const provider = new firebase.auth.GoogleAuthProvider()
  provider.addScope('https://www.googleapis.com/auth/calendar')
  provider.addScope('https://www.googleapis.com/auth/userinfo.profile')
  provider.addScope('https://www.googleapis.com/auth/userinfo.email')
  provider.addScope('https://www.googleapis.com/auth/admin.directory.resource.calendar.readonly')
  provider.setCustomParameters({ 'prompt': 'consent' })
  return firebase.auth().signInWithPopup(provider)
}

const signInMicrosoft = async () => {
  const provider = new firebase.auth.OAuthProvider('microsoft.com')
  // provider.setCustomParameters({ 'prompt': 'consent' })
  provider.setCustomParameters({ 'prompt': 'select_account' })
  provider.addScope('https://graph.microsoft.com/Calendars.ReadWrite')
  provider.addScope('https://graph.microsoft.com/User.Read')
  provider.addScope('https://graph.microsoft.com/Place.Read.All')
  provider.addScope('https://graph.microsoft.com/OnlineMeetings.ReadWrite')
  provider.addScope('offline_access')
  return firebase.auth().signInWithPopup(provider)
}

const signOut = () => {
  return firebase.auth().signOut()
}

export default {
  firebaseApp,
  firebaseAuth,
  getCurrentToken,
  getCurrentUser,
  signInGoogle,
  signInMicrosoft,
  signOut
}
